import { MapLayerInfo } from '@app/models/data-types/map-layer-info';

export const layers: MapLayerInfo[] = [
	{
		name: 'Mappa dei Transiti totali',
		modal: {
			header: "Informazioni sull'utilizzo di numero di transiti",
			body: '',
		},
		selected: true,
		legend: [
			{ label: '0 - 200.000', iconPath: './assets/images/interval1.jpg' },
			{ label: '200.000 - 400.000', iconPath: './assets/images/interval2.jpg' },
			{ label: '400.000 - 600.000', iconPath: './assets/images/interval3.jpg' },
			{ label: '600.000 - 800.000', iconPath: './assets/images/interval4.jpg' },
			{ label: '800.000 - 1.500.000', iconPath: './assets/images/interval5.jpg' },
		],
		themes: [
			{
				name: 'RERCTA_Viabilita:NUM_TRANSITI_APP_MM',
				style: 'RERCTA_Viabilita:NUM_TRANSITI_APP',
			},
			{
				name: 'RERCTA_Viabilita:NUM_TRANSITI_APP_GG',
				style: 'RERCTA_Viabilita:NUM_TRANSITI_APP',
			},
		],
		visibleFiltersIds: ['giorno', 'mese', 'postazioni', 'provincia', 'comune', 'strade'],
	},
];
